var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "lookup" }, [
    _c("div", { staticClass: "lookup__head" }, [
      _c("h2", [_vm._v("Platform Lookup")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "link--go-back",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.goBackEvent($event)
            }
          }
        },
        [_vm._v("\n      Go Back\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "lookup__body" },
      [
        _c("div", { staticClass: "body__left" }, [
          _c("div", { staticClass: "body__v-bar-content" }, [
            _c(
              "div",
              { staticClass: "body__content" },
              [
                _c("div", { staticClass: "lookup__search" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.search($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "lookup__search--input" },
                        [
                          _c("unum-textbox", {
                            attrs: {
                              name: "lookupTerms",
                              label: "Search Platforms",
                              placeholder: "Search Platforms",
                              hideLabel: "",
                              noMargin: ""
                            },
                            on: { input: _vm.closeCompareDrawer },
                            model: {
                              value: _vm.lookupTerms,
                              callback: function($$v) {
                                _vm.lookupTerms =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "lookupTerms"
                            }
                          }),
                          _vm._v(" "),
                          _vm.lookupTerms.length > 0
                            ? _c(
                                "span",
                                {
                                  staticClass: "lookup__search--clear-search",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.clearLookupTerms($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Clear Search\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("unum-button", { attrs: { color: "green" } }, [
                        _vm._v("Search")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "results results--preferred" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul" }
                          },
                          _vm._l(_vm.preferredPlatformsSorted, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                class: {
                                  "results--currentPlatform": _vm.isCurrent(
                                    platform
                                  )
                                },
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setCurrentPlatform(platform)
                                        _vm.closeCompareDrawer()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                  "
                                    ),
                                    _vm.is.dev
                                      ? _c(
                                          "span",
                                          { staticClass: "platform-priority" },
                                          [
                                            _vm._v(
                                              "\n                    priority: " +
                                                _vm._s(
                                                  _vm.platformPriority(
                                                    platform.priority
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.removePlatformEvent(
                                              platform
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "results results--fully-integrated" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul" }
                          },
                          _vm._l(_vm.fullyIntegratedPlatformsSorted, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                class: {
                                  "results--currentPlatform": _vm.isCurrent(
                                    platform
                                  )
                                },
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setCurrentPlatform(platform)
                                        _vm.closeCompareDrawer()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                  "
                                    ),
                                    _vm.is.dev
                                      ? _c(
                                          "span",
                                          { staticClass: "platform-priority" },
                                          [
                                            _vm._v(
                                              "\n                    priority: " +
                                                _vm._s(
                                                  _vm.platformPriority(
                                                    platform.priority
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.removePlatformEvent(
                                              platform
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "results results--future-integration" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul" }
                          },
                          _vm._l(_vm.futureIntegrationPlatformsSorted, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                class: {
                                  "results--currentPlatform": _vm.isCurrent(
                                    platform
                                  )
                                },
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setCurrentPlatform(platform)
                                        _vm.closeCompareDrawer()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                  "
                                    ),
                                    _vm.is.dev
                                      ? _c(
                                          "span",
                                          { staticClass: "platform-priority" },
                                          [
                                            _vm._v(
                                              "\n                    priority: " +
                                                _vm._s(
                                                  _vm.platformPriority(
                                                    platform.priority
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.removePlatformEvent(
                                              platform
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "results results--product-hosted" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul" }
                          },
                          _vm._l(_vm.productHostedSortedResults, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.viewFinal(platform)
                                        _vm.closeCompareDrawer()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.removePlatformEvent(
                                              platform
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.lookupTerms.length > 0
                    ? _c(
                        "section",
                        { staticClass: "results results--not-integrated" },
                        [
                          _c(
                            "unum-button",
                            {
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.noPlatform($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Don't See your platform?\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body__right" }, [
          _c(
            "div",
            { staticClass: "body__v-bar-content" },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  this.currentPlatform
                    ? [
                        this.currentPlatform.status !== "product_hosted"
                          ? _c("router-view")
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              !this.currentPlatform
                ? [
                    _c(
                      "div",
                      { staticClass: "lookup__unselected" },
                      [
                        _c(
                          "unum-button",
                          {
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.noPlatform($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              Don't See Your Platform?\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              this.currentPlatform
                ? [
                    this.currentPlatform.status === "product_hosted"
                      ? _c(
                          "div",
                          { staticClass: "lookup__unselected" },
                          [
                            _c(
                              "unum-button",
                              {
                                nativeOn: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.noPlatform($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Don't See Your Platform?\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("unum-drawer-compare")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "results__header" }, [
      _c("h3", [_vm._v("Preferred Solutions")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "results__header" }, [
      _c("h3", [_vm._v("Fully Integrated")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "results__header" }, [
      _c("h3", [_vm._v("Future Integration")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "results__header" }, [
      _c("h3", [_vm._v("Product Hosted")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-397d02aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-397d02aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lookup.vue
// module id = null
// module chunks = 